import { Selections } from "../../../services/api";

const startDate = (selection: Selections) =>
  new Date(selection.published_at).toLocaleDateString("en-GB", { day: "numeric", month: "short" });

// "Coming soon": a row of text cards you swipe / scroll sideways, like the mobile app.
// Title, release date and the start of the description; dimmed, with a dashed outline,
// because upcoming selections can't be opened yet.
const UpcomingSelections = ({ selections }: { selections: Selections[] }) => (
  <div className="upcomingSelections">
    {selections.map((selection) => (
      <div key={selection.id} className="upcomingSelections__card" aria-label={`${selection.title}, out ${startDate(selection)}`}>
        <h3 className="upcomingSelections__title">{selection.title}</h3>
        <p className="upcomingSelections__out">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>
          Out {startDate(selection)}
        </p>
        {selection.description && <p className="upcomingSelections__description">{selection.description}</p>}
      </div>
    ))}
  </div>
);

export default UpcomingSelections;
